import { Badge } from '@/components/ui/badge';
import { formatRelative } from '@/lib/time';
import { Thumbnail } from './Thumbnail';

// A "revision" in the API is a submission doc with status='changes_requested'.
// Field names mirror the submissions collection.
export type Revision = {
  id: string;
  school_name?: string;
  sportType?: string;
  status?: string;
  revision?: number;
  rep_change_notes?: string;
  createdAt?: string;
  rep_last_action_at?: string;
  lastRevisionAt?: string;
  lastRevisionNotes?: string;
  tier1LogoPath?: string | null;
};

export function RevisionRow({ r, onClick, showKind = false }: { r: Revision; onClick: () => void; showKind?: boolean }) {
  const round = r.revision && r.revision > 1 ? `Round ${r.revision}` : 'Open';
  const lastAction = r.lastRevisionAt || r.rep_last_action_at || r.createdAt;
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-3 border-b border-divider px-3 py-2 text-left hover:bg-bg/60 last:border-b-0"
    >
      {showKind && <Badge className="w-12 justify-center bg-bg text-muted">Prize</Badge>}
      <Thumbnail path={r.tier1LogoPath} alt="logo" className="h-8 w-8" />
      <span className="font-mono text-[10px] text-subtle w-20 shrink-0">{r.id.slice(0, 12)}</span>
      <span className="flex-1 truncate text-[12px]" title={r.lastRevisionNotes || r.rep_change_notes || undefined}>
        {r.school_name || 'Unknown'}{r.sportType ? ` · ${r.sportType}` : ''}
        {(r.lastRevisionNotes || r.rep_change_notes) && <span className="ml-2 text-muted">— {r.lastRevisionNotes || r.rep_change_notes}</span>}
      </span>
      <Badge className="bg-warning/10 text-warning">{round}</Badge>
      <span className="w-12 shrink-0 text-right text-[11px] text-muted">
        {lastAction ? formatRelative(lastAction) : ''}
      </span>
    </button>
  );
}
